//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { previewDataInterface } from '@/api/systemData/dataInterface';
export default {
  name: 'PopupSelect',
  props: {
    value: {
      default: ''
    },
    interfaceId: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    propsValue: {
      type: String,
      default: ''
    },
    columnOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data: function data() {
    return {
      list: [],
      filteredList: [],
      innerValue: '',
      keyword: '',
      checked: '',
      checkedTxt: '',
      listLoading: false,
      visible: false,
      refreshDataList: []
    };
  },
  watch: {
    value: function value(val) {
      this.setDefault();
    }
  },
  computed: {
    propsLabel: function propsLabel() {
      return this.columnOptions[0].value;
    }
  },
  created: function created() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var _this = this;
      if (!this.interfaceId) return;
      this.listLoading = true;
      previewDataInterface(this.interfaceId).then(function (res) {
        console.log(res);
        _this.list = res.data;
        _this.filteredList = _this.list;
        _this.listLoading = false;
        _this.setDefault();
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    search: function search() {
      var _this2 = this;
      if (!this.keyword) {
        this.filteredList = this.list;
        return;
      }
      this.filteredList = this.list.filter(function (o) {
        return _this2.columnOptions.some(function (option) {
          return option.value && o[option.value] && o[option.value].indexOf(_this2.keyword) > -1;
        });
      });
    },
    reset: function reset() {
      this.keyword = '';
      this.filteredList = this.list;
    },
    refresh: function refresh() {
      this.keyword = '';
      this.getData();
    },
    openDialog: function openDialog() {
      if (this.disabled) return;
      this.keyword = '';
      this.checked = this.value;
      this.visible = true;
      if (!this.list.length) {
        this.getData();
      } else {
        this.filteredList = this.list;
      }
    },
    clear: function clear() {
      this.checked = '';
      this.innerValue = '';
      this.$emit('input', this.checked);
      this.$emit('change', this.checked);
      this.$emit('refreshDataList', []);
    },
    select: function select() {
      if (!this.checked) return;
      this.innerValue = this.checkedTxt;
      this.$emit('input', this.checked);
      this.$emit('change', this.checked);
      // this.$emit("refreshDataList", this.refreshDataList);
      this.visible = false;
    },
    rowClick: function rowClick(row) {
      // this.refreshDataList = row;
      this.checked = row[this.propsValue];
      this.checkedTxt = row[this.propsLabel];
    },
    setDefault: function setDefault() {
      if (!this.value) {
        this.$emit('refreshDataList', []);
        return this.innerValue = '';
      }
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i][this.propsValue] === this.value) {
          this.innerValue = this.list[i][this.propsLabel];
          this.$emit('refreshDataList', this.list[i]);
          break;
        }
      }
    }
  }
};